import { render, staticRenderFns } from "./SBJDataYJ.vue?vue&type=template&id=e8059e4c&scoped=true&"
import script from "./SBJDataYJ.vue?vue&type=script&lang=js&"
export * from "./SBJDataYJ.vue?vue&type=script&lang=js&"
import style0 from "./SBJDataYJ.vue?vue&type=style&index=0&id=e8059e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8059e4c",
  null
  
)

export default component.exports